import { useSearchParams } from 'react-router-dom';

// Custom hook to get query params as an object
function useQueryParams() {
  const [searchParams] = useSearchParams();
  const params = {};
  
  searchParams.forEach((value, key) => {
    params[key] = value;
  });
  
  return params;
}

export default useQueryParams;
